import { size } from "polished";
import styled, { css } from "styled-components";
import GBFlag from "../img/flags/gb.svg?react";
import SAFlag from "../img/flags/sa.svg?react";

const FlagList = styled.ul`
  display: flex;
  gap: ${({ theme }) => theme.space[2]};
  margin: 0;
  /* padding: 1rem 0 0; */
  padding: 0;
  list-style-type: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    padding: 1rem 0 0;
  }
`;

const FlagItem = styled.li`
  display: inherit;
  padding-inline-end: ${({ theme }) => theme.space[2]};
  vertical-align: middle;
  line-height: 1;

  &:not(:last-child) {
    border-inline-end: 1px solid white;
  }
`;

const FlagLink = styled.a`
  display: inherit;
`;

const FlagStyles = css`
  ${size(23, 35)}

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    ${size(17, 28)}
  }
`;

const StyledSAFlag = styled(SAFlag)`
  ${FlagStyles}
`;

const StyledGBFlag = styled(GBFlag)`
  ${FlagStyles}
`;

const LanguageFlags = () => {
  return (
    <FlagList>
      <FlagItem>
        <FlagLink href="https://fantasy.spl.com.sa/">
          <StyledSAFlag />
        </FlagLink>
      </FlagItem>
      <FlagItem>
        <FlagLink href="https://en.fantasy.spl.com.sa/">
          <StyledGBFlag />
        </FlagLink>
      </FlagItem>
    </FlagList>
  );
};

export default LanguageFlags;
